import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "section" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Otrosko',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.otrosko.title'),
    cover: require('@/assets/covers/exam-boy.jpg'),
    "close-button-dark": true,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.otrosko.gradimoCeTitle')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('articles.otrosko.gradimoP1')
          }, null, 8, _hoisted_2),
          _createVNode(_component_a_circular_image, {
            image: require('@/assets/photos/child-on-chair.jpg'),
            class: "my-rem1"
          }, null, 8, ["image"]),
          _createElementVNode("span", {
            innerHTML: _ctx.$t('articles.otrosko.gradimoP2')
          }, null, 8, _hoisted_3)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.otrosko.ortodontTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/myobrace.jpg'),
          float: "left"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('articles.otrosko.ortodontP')
          }, null, 8, _hoisted_5),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'myobrace')))
          }, "Myobrace"),
          _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.otrosko.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'splosno')))
          }, _toDisplayString(_ctx.$t('articles.otrosko.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.otrosko.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})